<div class="wrapper wrapper-full-page">
    <div class="backImage" data-color="azure">
        <section>
            <div class="loginHeader">
                <!--<div class="col-md-12 text-right customlinks">
                    <span><a href="https://community.ipeccoaching.com" target="_blank">Community Hub</a></span>
                    <span><a href="https://www.oneideaaway.com/coaches" target="_blank">Coach directory</a></span>
                </div>-->
            </div>
        </section>


        <div class="content">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
                        <!--<form (ngSubmit)="login(loginForm)" #loginForm="ngForm" novalidate="">-->
                        <form (ngSubmit)="checkUserSystem(email.value)" #loginForm="ngForm" novalidate="">

                            <div class="card">
                                <div class="logo">
                                    <img src="/assets/img/logo_eli.png" />
                                    <!--<div>
                                        <h4>Welcome!</h4>
                                    </div>-->
                                </div>

                                <div class="content">
                                    <div  class="form-group">
                                        <label>Email address</label>
                                        <input id="email" (keypress)="preventSpace(email.value, $event)" 
                                               (keyup)="preventSpace(email.value, $event)" 
                                               class="form-control" placeholder="Enter email" 
                                               name="email" required="" [(ngModel)]="user.email" #email="ngModel">
                                    </div>
                                    <div *ngIf="isOldUser" class="form-group">
                                        <label>Password</label>
                                        <input passwordDirective id="pass"
                                                (keypress)="preventSpace(pass.value, $event)"
                                                (keyup)="preventSpace(pass.value, $event)"
                                                class="form-control" placeholder="Password"
                                                type="password" name="pass" required=""
                                                [(ngModel)]="user.pass" #pass="ngModel">
                                    </div>
                                </div>

                                <div *ngIf="isOldUser" style="margin: 0 16px -20px;" class="text-right">
                                    <a (click)="showForgotPasswordModal()" style="cursor: pointer; color: #4d9fd5;">Forgot password</a>
                                </div>
                                <br />
                                <br />
                                <!--[disabled]="!loginForm.valid"-->
                                <div class="footer text-center">                                    
                                    <input *ngIf="!isOldUser" class="btn btn-fill btn-info btn-wd" (click)="checkUserSystem(email.value)" value="Log In" type="button" />

                                    <button *ngIf="isOldUser" class="btn btn-fill btn-info btn-wd" type="submit" (click)="authenticateUser(loginForm)">
                                        Login
                                    </button>
                                    <!--<a [routerLink]="['../CLIENT/ACCOUNT_ACTIVATION/test@test.com']">Account activation</a>-->
                                </div>
                                <br />
                            </div>

                        </form>

                    </div>
                </div>
            </div>
        </div>

        <section>
            <div class="loginFooter">
                <div class="col-md-12 text-right">
                    <p>2007 - {{currentYear}} iPEC Coaching. All Rights Reserved.</p>
                </div>
            </div>
        </section>
    </div>
</div>

<!-- forgot password MODAL-->
<div id="forgotPassword" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Forgot password</h2>
                <button type="button" class="close" (click)="hideForgotPasswordModal()" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-xs-2">
                        <label><b style="color:#000;">Email: </b></label>
                    </div>
                    <div class="col-xs-10">
                        <input style="width:100%;" name="email" email placeholder="Email" #forgotEmail (keypress)="preventSpace(email.value, $event)" type="email" value="" id="forgotEmail" />
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button (click)="hideForgotPasswordModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button style="margin-right: 15px;" [disabled]="" (click)="sendPassword(forgotEmail.value)" type="button" class="btn btn-primary">Send Password</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
